import axiosInstance from './axiosConfig';

export const fetchFirstSuccessful = async (endpoints, config = {}) => {
    let lastError = null;

    for (const endpoint of endpoints) {
        try {
            const response = await axiosInstance.get(endpoint, config);
            return response.data;
        } catch (error) {
            const status = error?.response?.status;
            if (status && ![404, 405].includes(status)) {
                throw error;
            }
            lastError = error;
        }
    }

    if (lastError) {
        throw lastError;
    }

    throw new Error('No endpoint configured');
};

export const toArray = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    if (Array.isArray(value?.items)) return value.items;
    return [];
};

export const normalizeStatus = (status) => String(status || 'unknown').toLowerCase();

export const formatShortDate = (value) => {
    if (!value) return '—';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};
